// angular
import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse } from '@angular/common/http';

// addon
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

// store
import { Store } from '@ngrx/store';
import * as fromStore from '@store/index';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private store: Store<fromStore.State>) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          this.store.dispatch(fromStore.UserActions.logout());
        }

        return throwError(error.error);
      }),
    );
  }
}
